import { Pipe, PipeTransform } from '@angular/core';
import { AttributeItem } from 'src/app/users/_interfaces/users-admin';
import { ProcessConfig, QuestionConfig, QuestionGroup } from '../interfaces/process-config.interface';

@Pipe({
    name: 'processConfigFilter'
})
export class ProcessConfigFilterPipe implements PipeTransform {
    transform(
        processConfig: ProcessConfig,
        attributes: AttributeItem[]
    ): ProcessConfig {
        if (!processConfig || !attributes) {
            return processConfig;
        }

        // Filtra perguntas em cada grupo
        processConfig.questionsGroups = processConfig.questionsGroups
            .map((group: QuestionGroup) => {
                const returnQuestions: QuestionConfig[] = [];
                group.questions.forEach((question: QuestionConfig) => {
                    if (!question.attributes || question.attributes.length === 0) {
                        returnQuestions.push(question);
                        return;
                    }
                    const andAttributes = question.attributes.filter(attr => attr.anD_OR === 0);
                    const orAttributes = question.attributes.filter(attr => attr.anD_OR === 1);
                    let include = true;
                    if (
                        andAttributes.length > 0 &&
                        !andAttributes.every(ga => attributes && attributes.some(a => a.id === ga.attributeId))
                    ) {
                        include = false;
                    }
                    if (
                        include &&
                        orAttributes.length > 0 &&
                        !orAttributes.some(ga => attributes && attributes.some(a => a.id === ga.attributeId))
                    ) {
                        include = false;
                    }
                    if (include) {
                        returnQuestions.push(question);
                    }
                });
                group.questions = returnQuestions;
                return group;
            })
            .filter((group: QuestionGroup) => group.questions.length > 0); // Remove grupos vazios

        // Filtra perguntas standalone
        const returnQuestions: QuestionConfig[] = [];
        processConfig.questions.forEach((question: QuestionConfig) => {
            if (!question.attributes || question.attributes.length === 0) {
                returnQuestions.push(question);
                return;
            }
            const andAttributes = question.attributes.filter(attr => attr.anD_OR === 0);
            const orAttributes = question.attributes.filter(attr => attr.anD_OR === 1);
            let include = true;
            if (
                andAttributes.length > 0 &&
                !andAttributes.every(ga => attributes && attributes.some(a => a.id === ga.attributeId))
            ) {
                include = false;
            }
            if (
                include &&
                orAttributes.length > 0 &&
                !orAttributes.some(ga => attributes && attributes.some(a => a.id === ga.attributeId))
            ) {
                include = false;
            }
            if (include) {
                returnQuestions.push(question);
            }
        });
        processConfig.questions = returnQuestions;

        return processConfig;
    }
}